import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { updateHttpStatus as dispatchUpdateHttpStatus } from '../../actions/httpStatus';
import NotFound from './NotFound';

const NOT_FOUND_HTTP_STATUS = 404;

class NotFoundContainer extends React.Component {
    constructor(props) {
        super(props);

        const { shouldDispatchHttpStatus, updateHttpStatus } = this.props;

        // this will for now only be used by Contento views
        if (shouldDispatchHttpStatus) {
            updateHttpStatus();
        }
    }

    render() {
        // eslint-disable-next-line react/jsx-props-no-spreading
        return <NotFound {...this.props} />;
    }
}

NotFoundContainer.propTypes = {
    shouldDispatchHttpStatus: PropTypes.bool,
    baseContainer: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) => ({
    updateHttpStatus: () => dispatch(dispatchUpdateHttpStatus(NOT_FOUND_HTTP_STATUS)),
});

export default connect(null, mapDispatchToProps)(NotFoundContainer);
